import { makeStyles } from "@mui/styles";

export const AdminPageStyle = makeStyles((theme) => {
  return {
    container: {
      background: "var(--bg-page)",
      minHeight: "100vh",
      position: "relative",
    },
    backgroundVideo: {
      display: "none", // Obsolete
    },

    formContainer: {
      padding: "24px",
      display: "flex",
      flexDirection: "column",
      gap: "16px",
    },

    // Legacy layout blocks removed
    mainContent: {
      height: `calc(100vh - 160px)`,
      marginTop: "48px",
      marginLeft: "var(--sidebar-width)",
      padding: "12px 12px 20px 12px",
      background: "transparent !important",
      marginBottom: "40px",
      transition: "margin-left 0.3s ease",
    },
    mainAnalysisContent: {
      marginTop: "48px",
      marginLeft: "var(--sidebar-width)",
      padding: "12px 12px 40px 12px",
      background: "transparent !important",
      marginBottom: "40px",
      transition: "margin-left 0.3s ease",
    },
    fleetPaper: {
      margin: 10,
      padding: 20,
      border: "1px solid var(--divider)",
      borderRadius: "16px",
      background: theme.palette.background.paper,
      boxShadow: theme.palette.mode === 'dark' ? '0 8px 24px rgba(0,0,0,0.45)' : '0 8px 24px rgba(2, 6, 23, 0.06)',
    },
    fleetPaperMainDiv: {
      alignItems: "center",
      display: "flex",
      justifyContent: "space-between",
      // height: "auto",
      [theme.breakpoints.only("sm")]: {
        "@media screen and (max-width: 768px)": {
          overflowX: "scroll",
        },
      },
    },
    textFleetList: {
      fontSize: 14,
      fontWeight: "bold",
      marginLeft: 12,
    },
    fleetListSecDiv: {
      display: "flex",
      justifyContent: "end",
      alignItems: "center",
      width: "100%",
      margin: 2,

      ".MuiButtonBase-root": {
        width: "25%",
      },
    },
    divMt10: {
      marginTop: 5,
    },
    bgGraycolor: {
      color: "var(--brand-primary) !important",
      backgroundColor: "var(--bg-page) !important",
      boxShadow: "none !important",
      border: "1px solid var(--divider) !important",
      borderRadius: "8px !important",
      padding: "0px !important",
      marginRight: "11px !important",
      width: "25%",
      transition: "all 0.3s ease",
      "&:hover": {
        backgroundColor: "var(--surface) !important",
      }
    },

    fleetListButton: {
      fontSize: 12,
      display: "flex",
      justifyContent: "left",
    },
    fleetListButtonText: {
      fontSize: 12,
      textTransform: "capitalize",
      textAlign: "left",
      fontWeight: "500 !important",
    },
    fleetListInformation: {
      margin: 10,
    },
    textGeneralInfo: {
      fontSize: 14,
      fontWeight: "700 !important",
      textTransform: "capitalize !important",
      color: "var(--brand-primary) !important",
    },
    textGeneralInfoResult: {
      fontSize: "12px !important",
      fontWeight: "700 !important",
      textTransform: "uppercase !important",
      letterSpacing: "0.6px",
      color: "var(--brand-primary) !important",
      paddingTop: "0px !important",
    },
    textinput: {
      "& .MuiFilledInput-underline::before": {
        borderBottom: "2px solid var(--brand-primary) !important",
      },
      "& .MuiFilledInput-underline::after": {
        borderBottom: "2px solid var(--brand-primary) !important",
      },
      "& .MuiInputBase-root-MuiInput-root-MuiSelect-root": {
        padding: "0px !important",
        fontSize: "12px !important",
        color: "var(--text-primary) !important",
      },
      "& .MuiInput-root": {
        padding: "0px !important",
        fontSize: "12px !important",
        color: "var(--text-primary) !important",
      },
      "& .MuiInput-underline::after": {
        borderBottom: "2px solid var(--brand-primary) !important",
      },
      "& .MuiInput-underline::before": {
        borderBottom: "1px solid var(--divider) !important",
      },
      "& .MuiSelect-standard::after": {
        borderBottom: "2px solid var(--brand-primary) !important",
      },
      "& .MuiSelect-icon": {
        color: "var(--text-secondary) !important",
      },
      "& .MuiInputBase-input": {
        color: "var(--text-primary) !important",
      },
      "& .MuiInputBase-input.Mui-disabled": {
        color: "var(--text-secondary) !important",
        WebkitTextFillColor: "var(--text-secondary) !important",
      },
      fontSize: "12px !important",
      color: "var(--text-primary) !important",
    },
    fleetListGenInfoTtext: {
      width: "160px",
      marginRight: 20,
      fontSize: "12px !important",
      color: "var(--text-secondary) !important",
      fontWeight: "500 !important",
    },
    fleetListMileageText: {
      width: "200px",
      fontSize: "12px !important",
      color: "var(--text-secondary) !important",
      fontWeight: "500 !important",
    },
    fleetListTotalMileageText: {
      width: "200px",
      fontSize: "12px !important",
      color: "var(--brand-primary) !important",
      fontWeight: "600 !important",
    },
    fleetListGenInfoInputText: {
      width: "200px",
      fontSize: "12px !important",
      color: "var(--text-primary) !important",
      "@media screen and (max-width: 1356px)": {
        fontSize: "11px !important",
        marginRight: "0px !important",
      },
    },
    fleetListGenInfoDiv: {
      display: "flex",
      alignItems: "center",
    },
    fleetListDefultText: {
      width: "120px",
      fontSize: "12px !important",
      color: "gray !important",
      fontWeight: "500 !important",
    },
    mainContentFleet: {
      height: `auto`,
      marginTop: "60px",
      marginLeft: "var(--sidebar-width)",
      padding: 20,
      background: "transparent !important",
      marginBottom: "60px",
      transition: "margin-left 0.3s ease",
    },
    btn1: {
      display: "flex",
      justifyContent: "center",
      width: "100%",
      "&:focus": {
        background: "red !important",
      },
    },
    btn2: {
      background: "transparent !important",
      color: "var(--brand-secondary)",
      padding: "5px",
      borderTopLeftRadius: "8px",
      borderBottomLeftRadius: "8px",
      width: "35px",
      "&:focus": {
        background: "transparent !important",
      },
    },
    btn3: {
      background: "transparent !important",
      color: "var(--text-primary)",
      padding: "5px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      borderTopRightRadius: "8px !important",
      borderBottomRightRadius: "8px !important",
      width: "calc(100% - 35px)",
      "&:focus": {
        background: "transparent !important",
      },
    },
    focusVisible: {
      background: "red !important",
      "&:focus": {
        background: "red !important",
      },
    },
    saveButtonFleet: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    },
    headerFleet: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: 8,
      marginLeft: "17px !important",
      background: "var(--bg-page) !important",
      border: "1px solid var(--divider) !important",
      borderRadius: "8px !important",
      marginTop: "20px !important",
      color: "var(--brand-primary) !important",
      fontWeight: 600,
    },
    reportButton: {
      marginRight: "5px !important",
      fontWeight: "bold !important",
      color: "white !important",
      borderColor: "var(--brand-primary) !important",
      background: "var(--brand-primary) !important",
      borderRadius: "8px !important",
      textTransform: "none !important",
    },
    headerAnalysisReport: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      fontSize: "12px !important",
      padding: "10px 14px",
      background: "var(--surface) !important",
      border: "1px solid var(--divider) !important",
      borderRadius: "12px !important",
      marginBottom: "8px",
      boxShadow: theme.palette.mode === "dark"
        ? "0 2px 12px rgba(0,0,0,0.35)"
        : "0 2px 8px rgba(8,96,211,0.07)",
    },
    headerAnalysisName: {
      fontWeight: 700,
      fontSize: "13px !important",
      letterSpacing: "0.5px",
      color: "var(--brand-primary) !important",
    },
    gridContantReport: {
      height: `calc(100vh - 465px)`,
      width: "100%",
      marginLeft: 5,
      fontSize: "12px !important",
      // "@media screen and (max-width: 1439px)": {
      //   height: `calc(100vh - 160px)`,
      // },
      "@media screen and (max-width: 1385px)": {
        height: `calc(100vh - 470px)`,
      },
    },
    analysisDivMix: {
      padding: "8px 12px",
      fontSize: 13,
      fontWeight: 700,
      color: "var(--brand-primary) !important",
      letterSpacing: "0.3px",
    },
    headerButtonNext: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    },
    analysisSaveBox: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    headerSaveButton: {
      marginLeft: "10px",
      color: "#fff !important",
      fontWeight: "700 !important",
      backgroundColor: "var(--brand-primary) !important",
      borderRadius: "8px !important",
      "&:hover": { backgroundColor: "var(--brand-primary-hover) !important" },
    },
    totalSavingText: {
      backgroundColor: "var(--bg-page) !important",
      borderRadius: "4px",
      padding: "7px 5px",
      fontSize: "14px",
      fontWeight: 600,
      color: "var(--brand-primary)",
    },
    estimatedValueBox: {
      justifyContent: "end",
      display: "flex",
      marginTop: 10,
    },
    estimatedValueButton: {
      justifyContent: "end",
      display: "flex",
      alignItems: "center",
      background: "var(--brand-primary) !important",
      color: "var(--text-primary) !important",
    },
    aggridAnalysisReport: {
      width: "100%",
      borderRadius: "12px",
      overflow: "hidden",
      border: "1px solid var(--divider)",
      marginTop: "4px",
    },
    analysisListGenInfoTtext: {
      width: "460px",
      marginRight: 20,
      fontSize: "12px !important",
      color: "var(--text-secondary) !important",
      fontWeight: "500 !important",
      "@media screen and (max-width: 1356px)": {
        fontSize: "11px !important",
        marginRight: "0px !important",
      },
    },
    reportAnalysisButton: {
      marginRight: "10px !important",
      fontWeight: "600 !important",
      color: "var(--brand-primary) !important",
      borderColor: "var(--brand-primary) !important",
      background: "transparent !important",
      padding: "6px 20px !important",
      fontSize: "11px !important",
      borderRadius: "12px !important",
      border: "1px solid var(--brand-primary) !important",
      textTransform: "none !important",
      "&:hover": {
        background: "rgba(5, 85, 170, 0.05) !important",
      },
    },
    reportAnalysisSaveButton: {
      marginRight: "5px !important",
      fontWeight: "700 !important",
      color: "white !important",
      borderColor: "var(--brand-primary) !important",
      background: "var(--brand-primary) !important",
      padding: "5px 16px !important",
      fontSize: "12px !important",
      borderRadius: "6px !important",
      boxShadow: "0 4px 10px rgba(8,96,211,0.2) !important",
      "&:hover": {
        boxShadow: "0 6px 16px rgba(8,96,211,0.3) !important",
        transform: "translateY(-1px)",
      },
    },
    analysisResultTextDiv: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      padding: "3px 0",
    },
    accordinAnalysisResult: {
      height: "auto !important",
      minHeight: "170px !important",
      padding: "8px 10px 12px !important",
      "@media screen and (max-width: 1356px)": {
        minHeight: "160px !important",
        padding: "8px 5px 12px !important",
      },
      "@media screen and (max-width: 1200px)": {
        minHeight: "170px !important",
        padding: "8px 5px 12px !important",
      },
      "@media screen and (max-width: 995px)": {
        minHeight: "180px !important",
        padding: "8px 5px 12px !important",
      },
    },
    analysisTotalSavingButton: {
      display: "flex",
      alignItems: "center",
    },
    exportPowerBIButton: {
      color: "white !important",
      background: "var(--brand-primary) !important",
      border: "none !important",
      marginRight: "10px !important",
      borderRadius: "12px !important",
      padding: "6px 20px !important",
      fontWeight: "600 !important",
      textTransform: "none !important",
      "&:hover": {
        background: "var(--brand-primary-hover) !important",
      }
    },
    loadingCircular: {
      width: "20px",
      height: "20px",
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
    },
    fuelPriceSign: {
      marginRight: 2,
    },
    totalSavingsBadge: {
      display: "inline-flex",
      alignItems: "center",
      padding: "5px 14px",
      borderRadius: "20px",
      background: "linear-gradient(135deg, #16a34a 0%, #22c55e 100%)",
      boxShadow: theme.palette.mode === "dark"
        ? "0 0 14px rgba(34, 197, 94, 0.35)"
        : "0 2px 10px rgba(22, 163, 74, 0.3)",
      border: "1px solid rgba(255,255,255,0.15)",
      transition: "box-shadow 0.2s ease, transform 0.15s ease",
      "&:hover": {
        boxShadow: "0 4px 18px rgba(34, 197, 94, 0.45)",
        transform: "translateY(-1px)",
      },
    },
    totalSavingsBadgeLabel: {
      fontSize: "11px !important",
      fontWeight: "600 !important",
      color: "rgba(255,255,255,0.85) !important",
      letterSpacing: "0.3px",
    },
    totalSavingsBadgeValue: {
      fontSize: "13px !important",
      fontWeight: "800 !important",
      color: "#ffffff !important",
      letterSpacing: "0.2px",
    },
  };
});
